<h1 class="visually-hidden">{{ 'bundles.draftBatch' | transloco }}</h1>
<div class="padding">
  <mat-card>
    @if (batch && this.bundle) {
      <mat-card-content>
        <div class="flex-container">
          <div class="flex-item">
            <div class="flex-container">
              <span class="flex-item">{{ 'common.labels.bundle' | transloco }}</span><a class="flex-item-2"
            [routerLink]="['/bundles', bundle!.id]">{{ bundle!.name }}</a>
          </div>
          <div class="flex-container">
            <span class="flex-item">{{ 'bundles.description' | transloco }}</span><a class="flex-item-2">{{ bundle!.description
          }}</a>
        </div>
      </div>
      <div class="flex-item">
        <div class="flex-container">
          <span class="flex-item">{{ 'common.labels.batchType' | transloco }}</span><a class="flex-item-2">{{ batch!.batchTypeID | enumLabel:'batchType' }}</a>
        </div>
        <div class="flex-container">
          <span class="flex-item">{{ 'common.labels.batchState' | transloco }}</span><a class="flex-item-2 bold">{{ batch!.batchStateID | enumLabel:'batchState' }}</a>
      </div>
      <div class="flex-container">
        <span class="flex-item">{{ 'bundles.requestedBy' | transloco }}</span><a class="flex-item-2">{{ requestingUser }}</a>
      </div>
    </div>
  </div>
  @if (!isNormalizing) {
    <div class="flex-container">
      <mat-form-field class="form-field flex-item" appearance="outline">
        <mat-label>{{ 'common.labels.description' | transloco }}</mat-label>
        <input matInput name="description" [(ngModel)]="this.batch.description" [placeholder]="'common.labels.description' | transloco">
      </mat-form-field>
    </div>
    <div class="flex-container">
      <mat-slide-toggle [(ngModel)]="this.batch.emailUpdates" name="emailUpdates">
        {{ 'bundles.emailUpdates' | transloco }}
      </mat-slide-toggle>
    </div>
  }
  @if (!isNormalizing) {
    <div class="flex-container">
      <div class="flex-item-2">
        <input #fileInput hidden="true" type="file" onclick="this.value = null"
          (change)="onFileSelected($event)" accept=".csv" />
        <div class="flex-container">
          <button mat-flat-button color="primary" class="flex-item margin-top-bottom-15" (click)="fileInput.click()">
            {{ _document ? this._document.file?.name ?? this._document.document?.fileName ?? ('bundles.batchFile' | transloco) : ('common.labels.upload' | transloco) }}</button>
          <button type="button" mat-icon-button [attr.aria-label]="'bundles.deleteBatchFile' | transloco"
            class="flex-item margin-top-bottom-15" (click)="onDeleteDocument()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <div class="flex-item">
        @if (batch?.rawDocument) {
          <lib-batch-document-download class="download"
            [documentID]="batch!.rawDocument!.id" [documentName]="batch!.rawDocument!.fileName">
          </lib-batch-document-download>
        }
      </div>
    </div>
  }
  <mat-divider></mat-divider>
  @if (!isNormalizing) {
    <div class="flex-container">
      <button mat-raised-button (click)="deleteBatchConfirmation()" color="warn" class="margin-top"
        [attr.aria-label]="'bundles.deleteBatch' | transloco" >
        {{ 'common.buttons.delete' | transloco }}
      </button>
      <span class="spacer"></span>
      <button mat-raised-button (click)="downloadReadme()" color="primary" class="margin-top"
        [attr.aria-label]="'bundles.downloadReadme2' | transloco" [class.spinner]="this.isSaving"
        [disabled]="this.isSaving">
        {{ 'bundles.downloadReadme' | transloco }}
      </button>
      <span class="spacer"></span>
      <button mat-raised-button (click)="downloadSample()" color="primary" class="margin-top"
        [attr.aria-label]="'bundles.downloadSample' | transloco" [class.spinner]="this.isSaving"
        [disabled]="this.isSaving">
        {{ 'bundles.downloadSample' | transloco }}
      </button>
      <span class="spacer"></span>
      <button mat-raised-button (click)="submitBatchConfirmation()" color="accent" class="margin-top"
        [attr.aria-label]="'bundles.saveBatch' | transloco" [class.spinner]="this.isSaving"
        [disabled]="this.isSaving">
        {{ 'common.buttons.submit' | transloco }}
      </button>
    </div>
  }
  @if (!isNormalizing) {
    <lib-batch-validations
      [attachmentErrors]="attachmentErrors"
      [headerErrors]="headerErrors"
      [dataErrors]="dataErrors">
    </lib-batch-validations>
  }
  @if (isNormalizing) {
    <div class="flex-container-center">
      <h2>{{ 'bundles.normalizingValidating' | transloco }}</h2>
    </div>
  }
  @if (isNormalizing) {
    <div class="flex-container-center">
      <mat-spinner></mat-spinner>
    </div>
  }
</mat-card-content>
}
</mat-card>
</div>
